import { LookupTnsInputDTO } from "../model/input/lookupTnsInputDTO";
import { MiddlewareType } from "./middlewareType";
import logger from "../utils/logger";
import { lookupTnActions } from "../store/lookupTnSlice";
import { handleRequestError } from "./middlewareUtils";
import { lookupTnsAxios } from "../service/lookupTnService";
import { LookupTnsOutputDTO } from "../model/output/lookupTnsOutputDTO";

export function lookupTnMiddleware(input: LookupTnsInputDTO): MiddlewareType {
  return (dispatch, getState) => {
    logger.log("fetchCaseMiddleware invoked");
    if (!getState().lookupTn.isLoading) {
      logger.log("Inside of fetch case");
      dispatch(lookupTnActions.setIsLoading(true));
      lookupTnsAxios(input)
        .then((res) => {
          sanitizeBadKeys(res.data);
          dispatch(lookupTnActions.setLookupTnState(res.data.data));
          dispatch(lookupTnActions.setIsLoading(false));
        })
        .catch((err) => {
          handleRequestError(dispatch, err);
          dispatch(lookupTnActions.setIsLoading(false));
        });
    }
  };
}

const KEYS_TO_FILTER_OUT = [
  "response_code",
  "dns_response_message",
  "npdi",
  "response_message",
  "dns_response_code",
];

/**
 * For standard successful requests, we want to remove all of the DNS/Standard response code fluff from what is showed to users.
 *
 * @param {LookupTnsOutputDTO} output The response from the QS Portal backend. Will delete any unwanted keys from response in a successful response case.
 */
function sanitizeBadKeys(output: LookupTnsOutputDTO) {
  output.data.forEach((obj) => {
    if (
      Object.keys(obj).includes("response_code") &&
      (obj.response_code === "0" || obj.response_code === 0)
    ) {
      KEYS_TO_FILTER_OUT.forEach((badKey) => {
        if (Object.keys(obj).includes(badKey)) {
          delete obj[badKey];
        }
      });
    }
  });
}
